import React from 'react';
import Button from '../../Button/components/Button';

import styles from './PageController.module.scss';

const PageController = ({
  pageNumber,
  numberOfPages,
  goToFirstPage,
  goToPreviousPage,
  goToNextPage,
  goToLastPage,
}) => {
  return (
    <div id={styles.controller}>
      <div />
      <div className={styles.buttonWrapper}>
        <Button
          onClick={goToFirstPage}
          disabled={pageNumber == 1}
        >
          {'<<'}
        </Button>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          onClick={goToPreviousPage}
          disabled={pageNumber < 2}
        >
          {'<'}
        </Button>
      </div>
      <p>{`${pageNumber} of ${numberOfPages}`}</p>
      <div className={styles.buttonWrapper}>
        <Button
          onClick={goToNextPage}
          disabled={numberOfPages <= pageNumber}
        >
          {'>'}
        </Button>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          onClick={goToLastPage}
          disabled={numberOfPages == pageNumber}
        >
          {'>>'}
        </Button>
      </div>
      <div />
    </div>
  );
};

export default PageController;
